import { NgModule } from '@angular/core';
import { NbButtonModule, NbCardModule, NbFormFieldModule, NbIconModule, NbInputModule, NbSpinnerModule, NbTooltipModule } from "@nebular/theme";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ThemeModule } from '../../@theme/theme.module';
import { CommonModule } from '@angular/common';
import { FileUploadInputComponent } from './file-upload-input/file-upload-input.component';
import { ButtonsModule } from '../buttons/buttons.module';
import { ExtraFileUploadInputComponent } from './extra-file-upload-input/extra-file-upload-input.component';

@NgModule({
  imports: [
    CommonModule,
    ThemeModule,
    NbCardModule,
    NbButtonModule,
    NbIconModule,
    NbInputModule,
    FormsModule,
    ReactiveFormsModule,
    NbTooltipModule,
    NbSpinnerModule,
    ButtonsModule
  ],
  declarations: [
    FileUploadInputComponent,
    ExtraFileUploadInputComponent,
  ],
  exports: [
    FileUploadInputComponent,
    ExtraFileUploadInputComponent,
  ],
})
export class FormElementsModule { }
